export interface IInActiveReasonReportTotals {
    centerId: number,
    center: string,
    allReasons: number,
    unknownReasons: number,
    invalidPerc: string,
    invalidValue: number
}